/* Default texts for /scan + admin Studio — single source of truth */
export const DEFAULT_TEXTS = {
  scanHeroEyebrow: "Bienvenue à bord",
  scanHeroTitle: "Découvrez & gagnez",
  scanHeroTitleAccent: "gagnez",
  scanHeroSubtitle:
    "Pendant votre trajet, profitez d'offres exclusives et tentez votre chance au tirage du mois.",
  prizesSectionEyebrow: "À gagner",
  prizesSectionTitle: "Les lots à remporter",
  prizesInstantBadge: "Gain instantané",
  prizesMonthlyBadge: "Grand Tirage",
  optInTitle: "Tentez votre chance",
  optInSubtitle: "Inscrivez vos infos pour participer au tirage {prize}.",
  optInCta: "Tenter ma chance",
  sponsorBannerLabel: "Tirage offert par",
  consentText:
    "J'accepte que mon prénom et mon numéro soient utilisés pour ce tirage (Loi 2013-450 / ARTCI).",
  legalDetail:
    "Votre numéro est haché côté serveur (HMAC-SHA256) et jamais transmis aux annonceurs. La donnée est supprimée 90 jours après le tirage. Droits d'accès / suppression : privacy@gocab.ci.",
  gateLoadingLabel: "Votre ticket Scan & Win se charge",
  gateValidatedLabel: "Ticket validé — c'est à vous !",
  gateLockedHint: "Profitez des annonces. {seconds}s avant de pouvoir participer.",
  gateBonusLabel: "Bonus chance",
  footerLegal:
    "Données protégées · numéro haché côté serveur · suppression auto à 90 jours",
  winTemplate: "Bravo {name} ! {prize}",
  loseTemplate: "Merci {name}, vous êtes inscrit au tirage final.",
};

export const DEFAULT_GATE_SECONDS = 20;

export function fillTemplate(tpl, vars = {}) {
  if (!tpl) return "";
  return tpl.replace(/\{(\w+)\}/g, (_, k) => (vars[k] !== undefined ? vars[k] : `{${k}}`));
}

export function mergeTexts(custom) {
  return { ...DEFAULT_TEXTS, ...(custom || {}) };
}
